module.exports = __webpack_public_path__ + "img/mocar.f6b570bb.png";